export const partnerData = [
    {   
        id: 1,
        icon: "trusted-brand.png",
        alt: "TimeWatch",
        heading: "Trusted Brand",
        text: "Access a growing and reputable network"
    },
    {   
        id: 2,
        icon: "innovative-solution.png",
        alt: "TimeWatch",
        heading: "Innovative Solutions",
        text: "Work with the latest industry technologies"
    },
    {   
        id: 3,
        icon: "market-research.png",
        alt: "TimeWatch",
        heading: "Market Reach",
        text: "Expand your reach through our established platform"
    },
    {   
        id: 4,
        icon: "dedicated-support.png",
        alt: "TimeWatch",
        heading: "Dedicated Support",
        text: "Support assistance to help you succeed"
    }
]

export const process = [
    {   
        id: 1,
        icon: "trusted-brand.png",
        alt: "TimeWatch",
        heading: "Trusted Brand",
        text: "Access a growing and reputable network"
    },
    {   
        id: 2,
        icon: "innovative-solution.png",
        alt: "TimeWatch",
        heading: "Innovative Solutions",
        text: "Work with the latest industry technologies"
    },
    {   
        id: 3,
        icon: "market-research.png",
        alt: "TimeWatch",
        heading: "Market Reach",
        text: "Expand your reach through our established platform"
    },
    {   
        id: 4,
        icon: "dedicated-support.png",
        alt: "TimeWatch",
        heading: "Dedicated Support",
        text: "24/7 assistance to help you succeed"
    }
]